import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { t } from '@lingui/macro';

import { i18n } from '@src/i18n';
import {
  hideSnackBar as hideSnackBarAction,
  showSnackBar as showSnackBarAction,
} from '@src/store/ui/actions';
import { snackBarSelector } from '@src/store/ui/selectors';
import { Message } from '@src/store/ui/types';

const useSnackBar = () => {
  const dispatcher = useDispatch();
  const snackBar = useSelector(snackBarSelector);
  const hide = React.useCallback(() => dispatcher(hideSnackBarAction()), [
    dispatcher,
  ]);
  const show = React.useCallback(
    (message: Message) =>
      dispatcher(
        showSnackBarAction({
          content: message.content,
          action: {
            label: message.action?.label ?? i18n._(t`Confirm`),
            onPress: message.action?.onPress ?? hide,
          },
        })
      ),
    [dispatcher, hide]
  );

  return React.useMemo(() => {
    return { snackBar, show, hide };
  }, [hide, snackBar, show]);
};

export default useSnackBar;
